"use strict";

window.site = window.site || {};

/**
 * Init Hall Item Galleries slider
 * @class HallItemGalleries
 * @static
 */
site.HallItemGalleries = function HallItemGalleries() {
  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

  /**
   * Initializes the class.
   * @public
   */
  var init = function init() {
    // Abort if already initialized
    if (inited) {
      return false;
    }
    inited = true;
    var $hallItems = [].slice.call(document.querySelectorAll('.hall-item'));
    if ($hallItems) {
      $hallItems.forEach(function ($hallItem) {
        var $slider = $hallItem.querySelector('.hall-item-images');
        if ($slider) {
          var $images = [].slice.call($slider.querySelectorAll('img'));
          if ($images && $images.length > 1) {
            setTimeout(function () {
              var flkty = new Flickity($slider, {
                // options
                cellAlign: 'left',
                contain: true,
                pageDots: true,
                imagesLoaded: true,
                wrapAround: true,
                lazyLoad: true
              });
            }, 500);
          }
        }
      });
    }
    return true;
  };

  // Expose public methods & properties
  return {
    init: init
  };
}();